import { IIcon } from "components/icons/icons.types";
import React from "react";

const PdfIcon: React.FC<IIcon> = ({
  width = "16",
  height = "16",
  color = "currentColor"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 0.5H4C2.93913 0.5 1.92172 0.921424 1.17157 1.67157C0.421428 2.42172 0 3.43913 0 4.5V16.5C0 17.5609 0.421428 18.5783 1.17157 19.3284C1.92172 20.0786 2.93913 20.5 4 20.5H9C9.52958 20.4978 10.0366 20.2856 10.41 19.91L15.41 14.91C15.7551 14.5667 15.9586 14.1063 15.98 13.62C15.98 13.62 15.98 13.54 15.98 13.5V4.5C15.98 3.44259 15.5613 2.42819 14.8155 1.67862C14.0697 0.929046 13.0574 0.505287 12 0.5ZM3.77 5H12.25C12.5152 5 12.7696 5.10536 12.9571 5.29289C13.1446 5.48043 13.25 5.73478 13.25 6C13.25 6.26522 13.1446 6.51957 12.9571 6.70711C12.7696 6.89464 12.5152 7 12.25 7H3.77C3.50478 7 3.25043 6.89464 3.06289 6.70711C2.87536 6.51957 2.77 6.26522 2.77 6C2.77 5.73478 2.87536 5.48043 3.06289 5.29289C3.25043 5.10536 3.50478 5 3.77 5ZM5.5 16H3.75C3.48478 16 3.23043 15.8946 3.04289 15.7071C2.85536 15.5196 2.75 15.2652 2.75 15C2.75 14.7348 2.85536 14.4804 3.04289 14.2929C3.23043 14.1054 3.48478 14 3.75 14H5.5C5.76522 14 6.01957 14.1054 6.20711 14.2929C6.39464 14.4804 6.5 14.7348 6.5 15C6.5 15.2652 6.39464 15.5196 6.20711 15.7071C6.01957 15.8946 5.76522 16 5.5 16ZM8 11.5H3.75C3.48478 11.5 3.23043 11.3946 3.04289 11.2071C2.85536 11.0196 2.75 10.7652 2.75 10.5C2.75 10.2348 2.85536 9.98043 3.04289 9.79289C3.23043 9.60536 3.48478 9.5 3.75 9.5H8C8.26522 9.5 8.51957 9.60536 8.70711 9.79289C8.89464 9.98043 9 10.2348 9 10.5C9 10.7652 8.89464 11.0196 8.70711 11.2071C8.51957 11.3946 8.26522 11.5 8 11.5ZM13 14.5L10 17.5L9 18.5V15.17C9 14.9507 9.0432 14.7335 9.12712 14.5309C9.21105 14.3283 9.33406 14.1442 9.48913 13.9891C9.64421 13.8341 9.8283 13.711 10.0309 13.6271C10.2335 13.5432 10.4507 13.5 10.67 13.5H14L13 14.5Z"
        fill={color}
      />
    </svg>
  );
};

export { PdfIcon };
